import { Component, Input } from '@angular/core';
import { AnimalModel } from 'src/app/modules/animals/models/animal.model';
import { AnimalShelterModel } from 'src/app/shared/models/animal-shelter.model';
import { SharedModule } from '../../../../shared/shared.module';
import { RouterModule } from '@angular/router';
import { AnimalListItemComponent } from 'src/app/shared/components/animal-list-item/animal-list-item.component';

@Component({
  selector: 'app-animal-list-table',
  templateUrl: './animal-list-table.component.html',
  standalone: true,
  imports: [
    SharedModule,
    RouterModule
  ]
})
export class AnimalListTableComponent {
  @Input() animalEntries: any[] = [];
  @Input() animalsMap!: Map<number, AnimalModel>;
  @Input() shelterMap!: Map<number, AnimalShelterModel>;
  @Input() type: 'whereabouts' | 'origin' = 'whereabouts';
  @Input() emptyText = '';
  @Input() getDateFormat!: () => string;

  getAnimal(animalId: number): AnimalModel | undefined {
    return this.animalsMap.get(animalId);
  }

  get animalsForList(): AnimalModel[] {
    if (!this.animalEntries || !this.animalsMap) return [];

    return this.animalEntries
      .map(entry => {
        const id = entry?.animal?.id as number | undefined;
        if (!id) return undefined;
        return this.animalsMap.get(id);
      })
      .filter((a): a is AnimalModel => !!a);
  }
}